import { trim } from 'lodash';
import React, { createElement } from 'react';

type Formatter = (t: string) => React.ReactNode;
const FORMAT = {
  BOLD: '**',
  ITALIC: '*'
} as const;

const DEFAULT_FORMATTERS: {
  [FORMAT.BOLD]: Formatter;
  [FORMAT.ITALIC]: Formatter;
} = {
  [FORMAT.BOLD]: (t) => <strong>{t}</strong>,
  [FORMAT.ITALIC]: (t) => <em>{t}</em>
};

type Opts = {
  component?: 'div' | 'p' | 'span';
  formatter?: Partial<typeof DEFAULT_FORMATTERS>;
};

const REGEXP = /(\*(?:\*)?.+?(?:\*)?\*)/;
export const lightMdToJsx = (t: string, opts?: Opts) => {
  const component = opts?.component || 'span';
  const parts: string[] = t.split(REGEXP);
  const nodes: React.ReactNode[] = parts.map((p) => {
    if (p.startsWith(FORMAT.BOLD)) {
      const f =
        opts?.formatter?.[FORMAT.BOLD] || DEFAULT_FORMATTERS[FORMAT.BOLD];
      return f(trim(p, FORMAT.BOLD));
    }
    if (p.startsWith(FORMAT.ITALIC)) {
      const f =
        opts?.formatter?.[FORMAT.ITALIC] || DEFAULT_FORMATTERS[FORMAT.ITALIC];
      return f(trim(p, FORMAT.ITALIC));
    }
    return p;
  });
  return createElement(component, {}, ...nodes);
};

export const LightMdToJsx = ({
  children: t,
  ...opts
}: Opts & { children: string }) => {
  return lightMdToJsx(t, opts);
};

export const escapeReplacements = (t: string) => t.replace(/\{/g, '\u200b{'); // adding a zero width space will prevent the matching!
